module.exports = __webpack_public_path__ + "img/dream-btn-bg-active.531c0960.png";